// `204`: the payload is the abandoned run id, wrapped in an object (a payload is never a bare scalar).
export type WorkflowRunAbandonedPayload = {
	runId: number;
};

export type WorkflowRunAbandonedAction = {
	type: 'WORKFLOW_RUN_ABANDONED';
	payload: WorkflowRunAbandonedPayload;
	facilityId: number;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: WorkflowRunAbandonedPayload,
	facilityId: number,
	typeKey: string,
	subjectId: number,
): WorkflowRunAbandonedAction => ({
	type: 'WORKFLOW_RUN_ABANDONED',
	payload,
	facilityId,
	typeKey,
	subjectId,
});
